// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"653e1ae6","667":"cde794b4"}[chunkId] + ".chunk.js";
};